import { useSuspenseQuery } from '@tanstack/react-query'

import type { BusinessSummaryItem } from 'src/features/business/shared/schemas/business-item'
import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { PublicUserData } from 'src/shared/features/users/schemas/user'

export interface LynkSearchResults {
  businesses: BusinessSummaryItem[] | null
  users: PublicUserData[] | null
}

export interface LynkSearchResponse {
  results: LynkSearchResults | null
  summary: string
}

const getLynkSearch = async (query: string): Promise<LynkSearchResponse> => {
  try {
    const trimmedQuery = query.trim()

    const params = new URLSearchParams()
    params.append('query', trimmedQuery)

    const response = await getRequest<LynkSearchResponse>(`/users/lynk-search?${params.toString()}`)

    if (!response) {
      return {
        results: {
          businesses: null,
          users: null,
        },
        summary: '',
      }
    }

    return response
  } catch (error) {
    console.error('Error fetching lynk search:', error)
    return {
      summary: '',
      results: {
        businesses: null,
        users: null,
      },
    }
  }
}

export const useLynkSearch = (query: string) => {
  return useSuspenseQuery({
    queryKey: queries.search.lynk(query).queryKey,
    queryFn: () => getLynkSearch(query),
  })
}
